import { saveAs } from 'file-saver';
const svg2pdf = window.svg2pdf
const jsPDF = window.jsPDF

const serializer = new XMLSerializer();

export function exportSVGAsPDF(svg, filename, dimensions) {
	const pdf = new jsPDF('p', 'pt', dimensions)

	svg2pdf(svg, pdf, {
		xOffset: 0, yOffset: 0, scale: 1,
	});

	pdf.save(filename+'.pdf')
}

export function exportSVG(svg, filename) {
	const serializedSVG = serializer.serializeToString(svg);
	const xmlHeader = '<?xml version="1.0" standalone="no"?>'
	const blob = new Blob([xmlHeader + serializedSVG], { type: 'image/svg+xml' });
	saveAs(blob, filename);
}
